import React from 'react';
import { FormattedMessage } from 'react-intl';

export const defaultExportFormat = {
  extractId: 'DEFAULT_EXPORT_FORMAT',
  name: <FormattedMessage defaultMessage='Export my current view' description='defaultExportFormat.name' id='zDWCsr' />,
  isChecked: true,
};
